import '../chunk-PZ5AY32C.js';

// src/features/index.ts
var FEATURE_FLAG = {
  mlModels: "ml_models",
  catalogTemporal: "catalog_temporal",
  transactionQuality: "transaction_quality",
  askAi: "ask_ai",
  caseSuggestions: "case_suggestions"
};
var FEATURE_FLAGS = [
  { name: FEATURE_FLAG.mlModels, default: false, kind: "beta", description: "Model registry, training and transaction model inference. Off by default; enabled for explicitly selected test users or workspaces.", owner: "ml" },
  { name: FEATURE_FLAG.catalogTemporal, default: false, kind: "beta", description: "Author catalog assignments with multiple UTC time or chain-specific block validity periods.", owner: "catalog" },
  // ON by default: starting a check is how a transaction stored without an
  // assessment gets one. The flag stays as the per-customer off switch.
  { name: FEATURE_FLAG.transactionQuality, default: true, kind: "ops", description: "On-demand decoding quality checks and comparison runs. On by default; switch it off for a customer who should not start them.", owner: "transactions" },
  {
    name: FEATURE_FLAG.askAi,
    default: false,
    kind: "beta",
    description: "The Ask AI assistant: the dashboard header button, its command-palette entry and /ask-ai. Off by default because no service answers its /ai/chat endpoint yet; switch it on where that service is deployed.",
    owner: "front-ends"
  },
  {
    name: FEATURE_FLAG.caseSuggestions,
    // ON by default, unlike `ask_ai`: this one WORKS. It is a kill switch and a
    // per-customer opt-out, not a rollout gate — switching it off takes a
    // working panel away, so nobody gets it by an operator forgetting to act.
    default: true,
    kind: "beta",
    description: "The Suggestions panel on an investigation: what stands out in the case, worked out from its own transactions and counterparties by rules (no model). On by default; switch it off for a customer who does not want the product volunteering findings.",
    owner: "front-ends"
  }
];
function featureFlagDefault(name, registry = FEATURE_FLAGS) {
  return registry.find((flag) => flag.name === name)?.default ?? false;
}
var FEATURE_RUNGS = ["customer", "org", "tenant", "user"];
var FEATURE_FLAG_NAMES = new Set(FEATURE_FLAGS.map((f) => f.name));
function isKnownFeatureFlag(name) {
  return FEATURE_FLAG_NAMES.has(name);
}
function flagValues(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  return Object.fromEntries(
    Object.entries(value).filter(
      (entry) => typeof entry[1] === "boolean"
    )
  );
}
function resolveFeatureFlags(valuesByRung, registry = FEATURE_FLAGS) {
  const out = {};
  for (const flag of registry) {
    let enabled = flag.default;
    let source = "default";
    for (const rung of FEATURE_RUNGS) {
      const values = flagValues(valuesByRung[rung]);
      if (flag.name in values) {
        enabled = values[flag.name];
        source = rung;
      }
    }
    out[flag.name] = { name: flag.name, enabled, source };
  }
  return out;
}
function featureFlagLayer(response, registry = FEATURE_FLAGS) {
  const flags = response?.flags ?? {};
  return Object.fromEntries(
    registry.map((flag) => {
      const served = flags[flag.name];
      if (!served || served.source === "default") return [flag.name, flag.default];
      return [flag.name, served.enabled ?? flag.default];
    })
  );
}

export { FEATURE_FLAG, FEATURE_FLAGS, FEATURE_FLAG_NAMES, FEATURE_RUNGS, featureFlagDefault, featureFlagLayer, flagValues, isKnownFeatureFlag, resolveFeatureFlags };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map